module.exports = __webpack_public_path__ + "img/user-light.ed85b71d.svg";